module.exports = __webpack_public_path__ + "static/media/betterflosspro-3.4096d0b7.jpg";